export default {
  products: {
    isLoading: false,
    error: false,
    errorMessage: null,
    data: [],
    totalPage: 0,
    count: 0
  },
  product: {
    isLoading: false,
    error: false,
    errorMessage: null,
    data: {}
  }
};
